export const NEUTRAL_PALETTE = {
  pearl: "#F2F1EE",
  mist: "#D9D7D2",
  stone: "#B8B5AE",
  slate: "#8C8A84",
  anthracite: "#5E5D59",
} as const;
